import { render, staticRenderFns } from "./formAdminCategory.vue?vue&type=template&id=bbe25fb6"
import script from "./formAdminCategory.vue?vue&type=script&lang=js"
export * from "./formAdminCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports